const MONATSGRENZE_MS = 5 * 365 * 24 * 3600 * 1000

function utcDate(utcMs) {
	return new Date(utcMs)
}

function addUtcMonths(utcMs, monate) {
	const date = utcDate(utcMs)
	return Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + monate, 1)
}

function monthDifference(startUtcMs, endUtcMs) {
	const start = utcDate(startUtcMs)
	const ende = utcDate(endUtcMs)

	return (ende.getUTCFullYear() - start.getUTCFullYear()) * 12 + (ende.getUTCMonth() - start.getUTCMonth())
}

function formatMonatJahrKurz(utcMs) {
	return new Intl.DateTimeFormat("de-DE", {
		month: "short",
		year: "numeric",
		timeZone: "UTC",
	}).format(utcDate(utcMs))
}

function istMonatsansicht(min, max) {
	return max - min < MONATSGRENZE_MS
}

function projektionStartdatum(data) {
	const basis = data?.kreditstart || data?.startdatum
	if (!basis) return 0

	return Date.UTC(utcDate(basis).getUTCFullYear(), 0, 1)
}

function gruppierterBlockStart(chartData, chartX) {
	if (!isLaufzeitVariante(chartData)) return chartX

	const blockStart = chartXZuReal(chartX, chartData)
	return Date.UTC(utcDate(blockStart).getUTCFullYear(), utcDate(blockStart).getUTCMonth(), 1)
}

function gruppierterBlockEnd(chartData, chartX) {
	if (!isLaufzeitVariante(chartData)) return chartX

	return Math.min(addUtcMonths(gruppierterBlockStart(chartData, chartX), 11), chartData.enddatum)
}

export function isLaufzeitVariante(data) {
	return data?.charteinstellungen?.zeitachsen_variante === "laufzeit"
}

export function realZuChartX(utcMs, data) {
	if (!isLaufzeitVariante(data) || utcMs == null) return utcMs

	return addUtcMonths(projektionStartdatum(data), monthDifference(data.kreditstart, utcMs))
}

export function chartXZuReal(utcMs, data) {
	if (!isLaufzeitVariante(data) || utcMs == null) return utcMs

	return addUtcMonths(data.kreditstart, monthDifference(projektionStartdatum(data), utcMs))
}

export function chartMonatsLabel(chartData, chartX) {
	return formatMonatJahrKurz(chartXZuReal(chartX, chartData))
}

export function chartJahresLabel(chartData, chartX) {
	if (!isLaufzeitVariante(chartData)) return `${utcDate(chartX).getUTCFullYear()}`

	const start = gruppierterBlockStart(chartData, chartX)
	const ende = gruppierterBlockEnd(chartData, chartX)
	const startJahr = utcDate(start).getUTCFullYear()
	const endJahr = utcDate(ende).getUTCFullYear()

	return startJahr === endJahr ? `${startJahr}` : `${startJahr} - ${endJahr}`
}

export function chartAlterLabel(chartData, chartX, groupingAktiv) {
	if (typeof globalThis.ageLabelFormatter !== "function" || typeof globalThis.moment?.utc !== "function") return ""

	const realUtcMs = groupingAktiv ? gruppierterBlockEnd(chartData, chartX) : chartXZuReal(chartX, chartData)
	return globalThis.ageLabelFormatter(globalThis.moment.utc(realUtcMs))
}

export function updateDataGrouping(chart, min, max) {
	const groupingEnabled = !istMonatsansicht(min, max)

	chart.update({
		plotOptions: {
			series: {
				dataGrouping: {
					enabled: groupingEnabled,
					forced: groupingEnabled,
					units: groupingEnabled ? [["year", [1]]] : [["month", [1]]],
					anchor: "start",
					firstAnchor: "start",
					lastAnchor: "start",
				},
			},
		},
	})
}

export function zoomIn(chartKredit, event) {
	if (event.resetSelection) {
		chartKredit.onZoomReset?.()
		return true
	}

	const min = event.xAxis[0].min
	const max = event.xAxis[0].max
	const dataGrouping = event.target.xAxis[0].chart.options.plotOptions.series.dataGrouping

	chartKredit.onZoomIn?.()
	chartKredit.data.anzeigeformat = istMonatsansicht(min, max) ? "monat" : "jahr"

	if (istMonatsansicht(min, max) && dataGrouping.enabled) {
		const xAxis = event.target.xAxis[0]
		const minDate = new Date(min)
		const neuesMinJahr = minDate.getFullYear() + (minDate.getMonth() > 5 ? 1 : 0)
		const maxDate = new Date(max)
		const neuesMaxJahr = maxDate.getFullYear() + (maxDate.getMonth() > 5 ? 1 : 0)

		xAxis.setExtremes(Date.UTC(neuesMinJahr, 0, 1), Date.UTC(neuesMaxJahr, 11, 1))
		chartKredit.data.anzeigeformat = "monat"
		return false
	}

	return true
}

export function updateXAxisMinMax(chartKredit) {
	const seriesMaxValues = chartKredit.chart.series.map((serie) =>
		Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined,
	)
	const xAxisMaxValue = Math.max(
		realZuChartX(chartKredit.data.enddatum, chartKredit.data),
		...seriesMaxValues.filter((element) => element !== undefined),
	)

	chartKredit.chart.xAxis[0].update({ min: realZuChartX(chartKredit.data.startdatum, chartKredit.data), max: xAxisMaxValue })
}
